var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.363 19.778l1.414-1.414L13.413 12l6.364-6.364-1.414-1.414L12 10.586 5.635 4.222 4.22 5.636 10.585 12 4.22 18.364l1.414 1.414L12 13.414l6.364 6.364z"
  })));
}
export default __webpack_public_path__ + "58b7150d6f3737a5894f3391089995ff.svg";
export { SvgClose as ReactComponent };